import React, { useState } from 'react';
import { Controlled as CodeMirror } from 'react-codemirror2';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/material.css';
import 'codemirror/mode/xml/xml';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/css/css';
import './editor.css';
import 'codemirror/addon/comment/comment';
import 'codemirror/addon/hint/show-hint';
import 'codemirror/addon/hint/show-hint.css'
import 'codemirror/addon/hint/css-hint'
import 'codemirror/addon/hint/html-hint';
import 'codemirror/addon/hint/xml-hint'
import 'codemirror/addon/hint/javascript-hint'
import 'codemirror/mode/htmlmixed/htmlmixed';
import 'codemirror/addon/edit/closetag'
import 'codemirror/addon/edit/closebrackets'
function Editor({ name, lang, value, onChange, icon }) {
    const [cursorCheck, setCursorPost] = useState(false);

    //cursor problem fix later on
    const handleCursorActivity = (editor) => {
        if (cursorCheck) {
            var currentPosition = editor.getCursor();
            var newPosition = { line: currentPosition.line, ch: currentPosition.ch + 1 };
            editor.setCursor(newPosition);
            setCursorPost(false);
        }
    };

    return (
        <div className='codemirror my-4'>
            <div className="heading">
                <h1>
                    {icon}
                    <h1>{name}</h1>
                </h1>
            </div>
            <CodeMirror
                value={value}
                options={{
                    mode: lang,
                    theme: 'material',
                    lineNumbers: true,
                    lineWrapping: true,
                    scrollbarStyle: null,
                    // CodeMirror.hints.auto, 
                    extraKeys: {
                        'Ctrl-/': 'toggleComment',
                        'Ctrl-Space': 'autocomplete',
                    },
                    // autoCloseTags: true  give option to user to enable it or not? later on 
                    // autoCloseBrackets: true
                }}
                onBeforeChange={(editor, data, value) => {
                    // console.log(data);
                    if (data.text == '{}') {
                        console.log("work");
                        setCursorPost(true);
                    }
                    onChange(value);
                }}
                onCursorActivity={(editor) => {
                    // if (cursorCheck) {
                    handleCursorActivity(editor);

                    // }
                }}
            />
        </div>
    );
}

export default Editor;
